import { Layout } from 'antd';

const { Footer: Foot } = Layout;

function Footer() {
  return (
    <Foot style={{ textAlign: 'center' }}>MySG ©2024 byes-eco-gestes-web</Foot>
  );
}

export default Footer;
